import { render, staticRenderFns } from "./BulkCreateCoupons.vue?vue&type=template&id=0cf05bc8&"
import script from "./BulkCreateCoupons.vue?vue&type=script&lang=ts&"
export * from "./BulkCreateCoupons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports